module.exports = __webpack_public_path__ + "img/pay-tmp-normal-first.9883cb0f.png";